import React from 'react'
import { string } from 'prop-types'
import i18next from 'i18next'

import './CookieInformation.css'

const CookieInformation = ({ name, expiration, description }) => (
  <ul className="cookie-configuration-list">
    <li className="cookie-configuration-list__cookie">
      <span className="cookie-configuration-list__cookie-name">{name}</span>
      <ul>
        <li className="cookie-configuration-list__cookie-info">
          {i18next.t('cookies_configuration_expiration')}:{' '}
          {i18next.t(expiration)}
        </li>
        <li className="cookie-configuration-list__cookie-info">
          {i18next.t('cookies_configuration_description')}:{' '}
          {i18next.t(description)}
        </li>
      </ul>
    </li>
  </ul>
)

CookieInformation.propTypes = {
  name: string,
  expiration: string,
  description: string,
}

export { CookieInformation }
